.container {
  gap: var(--mirai-ui-space-S);
}

.input {
  box-sizing: border-box;
  height: calc(var(--mirai-ui-space-XL) + var(--mirai-ui-space-XXS));
}
